import { ALLOWED_MIME_TYPES } from './constants';

/**
 * Validate if a file type is supported
 * @param {File} file - The file to validate
 * @returns {boolean} - True if file type is supported
 */
export function isFileTypeSupported(file) {
  if (!file || !file.type) {
    // If file has no type, allow it (will be treated as application/octet-stream on server)
    return true;
  }
  
  const normalizedMimeType = file.type.toLowerCase().trim();
  
  // Check if exact match in whitelist
  const isAllowed = ALLOWED_MIME_TYPES.some(allowed => {
    return normalizedMimeType === allowed.toLowerCase();
  });
  
  // Also allow application/octet-stream as fallback for unknown/raw formats
  if (normalizedMimeType === 'application/octet-stream' || 
      normalizedMimeType === 'application/x-binary' || 
      normalizedMimeType === 'application/x-unknown') {
    return true;
  }
  
  return isAllowed;
}

